export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ? process.env.REACT_APP_API_BASE_URL : 'https://door-api.jobsity.com/v1/hodoor';
export const UI_BASE_URL = process.env.REACT_APP_UI_BASE_URL ? process.env.REACT_APP_UI_BASE_URL : 'https://door.jobsity.com';

export const TIMEOUT = 20000;

export const DATA_ACCESS_TOKEN = 'accessToken';
export const DATA_USER_DATA_KEY = 'userData';

export const SECURITY_CLIENT_ANY = '*';
export const SECURITY_ROLE_ADMIN = 'ROLE_ADMIN';
export const SECURITY_ROLE_OWNER = 'ROLE_OWNER';
export const SECURITY_ROLE_USER = 'ROLE_USER';

export const PATH_USERS = '/users';
export const PATH_USERS_CHECK = '/check/';
export const PATH_USERS_PASSWORD_FORGOT = '/password/forgot';
export const PATH_USERS_PASSWORD_RESET = '/password/reset';
export const PATH_CHANGE_PASSWORD = '/changePassword';
export const PATH_LOGIN = PATH_USERS + '/login';
export const PATH_REFRESH_TOKEN = PATH_USERS + '/refresh-token';
export const PATH_ACTIVE = '/active';
export const PATH_CLIENTS = '/clients';
export const PATH_ACCESSES = '/accesses';
export const PATH_ACCESSES_ALL = '/all';
export const PATH_ACTIONS = '/clients/{clientId}/actions';
export const PATH_TRIGGER = '/trigger';
export const PATH_EXPORT = '/export';
export const PATH_GROUPS = '/clients/{clientId}/groups';
export const PATH_CONNECTION_ACTIVITY = '/connection-activity';
export const PATH_INVITES = '/invites';
export const PATH_WS = API_BASE_URL + "/sockets/sws";

export const CONFIG_PAGE_ROWS = 20;
export const CONFIG_TABLE_MAX_X = 920;

export const PERMISSION_INVITES = "INVITES";


// WEBPACK FOOTER //
// ./src/app/constants/constants.js